export type TourStatus = 'in_progress' | 'completed' | 'skipped'

export interface TourProgress {
  status: TourStatus
  stepId: string
}

function storageKey(userId: string, guideId: string) {
  return `workhub:guide:v2:${guideId}:${userId}`
}

export function readTourProgress(userId: string, guideId: string): TourProgress | null {
  try {
    const raw = window.localStorage.getItem(storageKey(userId, guideId))
    if (!raw) return null
    const value = JSON.parse(raw) as Partial<TourProgress>
    if (!['in_progress', 'completed', 'skipped'].includes(String(value.status))) return null
    if (typeof value.stepId !== 'string') return null
    return { status: value.status as TourStatus, stepId: value.stepId }
  } catch {
    return null
  }
}

export function saveTourProgress(userId: string, guideId: string, progress: TourProgress) {
  try {
    window.localStorage.setItem(storageKey(userId, guideId), JSON.stringify(progress))
  } catch {
    // Guides remain usable when browser storage is unavailable.
  }
}
